<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>海事急難救助基金</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <div>和平電力所屬之行政區為花蓮縣，每年提撥固定比例之費用予花蓮區漁會協助漁業發展及救助。自 2023 年開始，和平電力於蘇澳區漁會設置「和平電力海事急難救助基金」，用以協助海上遭難之漁船及漁民，與其家屬生活。</div>
        <br>
        <div class="imgContainer1-1">
          <div class="imgTit">與蘇澳漁會海事急難救助管理基金會議</div>
        </div>
        <div class="imgContainer1-2"></div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default defineComponent({
  name: 'SocialRelief',
  components: {
    Header,
    Footer
  },
  data() {
    return {
    }
  },
  methods:{
  },
  mounted() {
    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-2") as HTMLElement, 0.55);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/socialRelief/kv.webp");
  background-position: center;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 {
  line-height: 2em;
}

.sect1 .imgContainer1-1 {
  margin: 20px 0;
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  background: url("@/assets/socialRelief/pic1_01.jpg") center;
  background-size: cover;
}

.sect1 .imgContainer1-1 .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}

.sect1 .imgContainer1-2 {
  border-radius: 30px;
  background: url("@/assets/socialRelief/pic1_02.jpg") center;
  background-size: cover;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }
}
</style>
